import {
  DEFAULT_THOUSANDS_SEPARATOR,
  CURRENCY_WITH_EXCLUSIVE_THOUSANDS_SEPARATOR,
  CURRENCY_WITH_DECIMALS,
  CURRENCY_SYMBOL_AT_END,
} from '@dragonfruit/constants/price';

export function formatThousands(currency, number) {
  const exclusiveSeparator =
    CURRENCY_WITH_EXCLUSIVE_THOUSANDS_SEPARATOR[currency];

  return number
    .toString()
    .replace(
      /(\d)(?=(\d{3})+(?!\d))/g,
      `$1${exclusiveSeparator || DEFAULT_THOUSANDS_SEPARATOR}`
    );
}

export function formatDecimals(currency, number) {
  if (!CURRENCY_WITH_DECIMALS.includes(currency)) return number;
  return Number.parseFloat(number).toFixed(2);
}

export function formatPriceNumber(currency, number) {
  if (!currency || isNaN(number)) return undefined;
  return formatThousands(currency, formatDecimals(currency, number));
}

export function formatPriceWithCurrency(currency, currencySymbol, number) {
  const formattedNumber = formatPriceNumber(currency, number);

  if (!formattedNumber) return undefined;

  const priceArray = [currencySymbol, formattedNumber];

  const isSymbolAtEnd = CURRENCY_SYMBOL_AT_END.includes(currency);

  if (isSymbolAtEnd) priceArray.reverse();

  return priceArray.join('');
}

/**
 * get the cheapest price value in a plan paymentMethod list.
 * @param {object} plan
 * @param {array} plan.paymentMethods
 */
export const getPlanLowestPrice = plan => {
  const { paymentMethods } = plan || {};
  if (!paymentMethods) return 0;

  const { price: lowestPrice = 0 } = paymentMethods.reduce(
    (prev, currentPaymentMethod) => {
      const { price: prevPrice } = prev;
      const { price } = currentPaymentMethod;
      return prevPrice < price ? prev : currentPaymentMethod;
    },
    {}
  );
  return lowestPrice;
};



// WEBPACK FOOTER //
// ./app/utils/priceParser.js